import React, { useState } from 'react';
import './Form.css';

import formImage from '../assets/images/form/form.webp';

function Form() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    city: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Formulário enviado com sucesso!');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <section 
      className="form-section" 
      id="home"
      style={{ backgroundImage: `url(${formImage})` }}
    >
      <div className="form-container">
        <h1>O canal da sua impressão 3D</h1>
        <h1>PERSONALIZADA!</h1>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="SEU NOME:"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="SEU MELHOR E-MAIL:"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="city"
            placeholder="SUA CIDADE:"
            value={formData.city}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="message"
            placeholder="O QUE GOSTARIA DE IMPRIMIR:"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit">SOLICITAR CONTATO</button>
        </form>
      </div>
    </section>
  );
}

export default Form;
